<template lang="pug">
  hotsite-dgc
    .conteudo(style="height:auto;")
      .row
        .col-xs-12
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-withbar.-upper Sobre a DGC
              small.more: router-link(:to="{ name: 'DGCSobre' }") Ver tudo
            .texto(slot="content")
              p.
                A Diretoria de Contratos tem a finalidade de planejar,
                acompanhar a execução físico-financeira e coordenar a
                fiscalização administrativa dos contratos de obras e serviços de
                engenharia, cessão patrimonial e de serviços de natureza
                continuada, em consonância com as políticas e diretrizes de
                governança em contratações e aquisições regulamentadas pelo
                Conselho de Administração da UFRN.
      .row.faixa.legislacao
        .col-xs-12
          //- LEGISLAÇÃO
          bloco.-nomargin.-softpadding
            header(slot="header")
              titulo.-upper
                i.fa.fa-calendar-o.fa-lg &nbsp;&nbsp;
                | Legislação
            .texto(slot="content")
              p
                strong LEI N° 8.666, DE 12 DE JUNHO DE 1993
                br
                | Regulamenta o art. 37, inciso XXI, da Constituição Federal, institui normas para licitações e contratos da Administração Pública e dá outras providências.
      //- .row
      //-   .col-xs-12
      //-     //- DESTAQUE
      //-     bloco.-nomargin.-softpadding
      //-       header(slot="header")
      //-         titulo.-upper
      //-           i.fa.fa-check-square-o.fa-lg &nbsp;&nbsp;
      //-           | Fiscalização de Contratos
      //-         small.more: router-link(:to="{ name: 'DGCContratos' }") Ver tudo
      //-       .texto(slot="content")
      //-         p
      //-           strong Contratos Vigentes na UFRN
      //-           br
      //-           br
      //-           | Para ter acesso aos contratos em vigor, basta clicas nos links abaixo:
      //-           br
      //-           br
</template>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import HotsiteDgc from 'PAGES/dgc/Base'
  import Listagem from 'COMPONENTS/BaseLista'
  import Titulo from 'COMPONENTS/ElementTitle'

  export default {
    components: {
      Bloco,
      HotsiteDgc,
      Listagem,
      Titulo
    }
  }
</script>

<style lang="scss" scoped>
.legislacao {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?128f95aa